import ComposeViewState from '../store/schema/ComposeViewState';

export default function canModifyRecipients(viewState: ComposeViewState) {
    const IRMData = viewState.IRMData;
    return !IRMData || IRMData.IsOwner || IRMData.ForwardAllowed;
}
